<template>
  <img
    v-if="icon"
    :src="fileUrl + 'uploads/cat_images/' + icon"
    :style="iconStyle"
    class="img-responsive"
  />
  <img v-else :style="iconStyle" src="@/assets/images/icons/categories.png" class="img-responsive" />
</template>
<script>
export default {
  name: "CategoryIcon",
  props: {
    icon: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "14px"
    },
    marginRight: {
      type: String,
      default: "6px"
    },
    marginTop: {
      type: String,
      default: "7px"
    }
  },
  computed: {
    iconStyle() {
      return {
        float: "left",
        marginRight: this.marginRight,
        width: this.width,
        marginTop: this.marginTop
      };
    }
  }
};
</script>
